import Sparkline from "../common/Sparkline";
import "./StatCard.css";

interface StatCardProps {
  title: string;
  number: string;
  sparklineData?: (number | null | undefined)[];
}

const StatCard = ({ title, number, sparklineData }: StatCardProps) => (
  <div className="stat-card">
    <div className="stat-card-label">{title}</div>
    <div className="stat-card-value">{number}</div>
    {sparklineData && (
      <Sparkline data={sparklineData} color="#98d8ff" height={32} />
    )}
  </div>
);

export default StatCard;
